import "./Sendemail.css";
import { useState, useRef, useEffect } from "react";
import { MdAttachFile, MdCancel, MdDeleteOutline, MdOutlineAnalytics, MdScheduleSend } from "react-icons/md";
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import RequestSentDetailsDS from "../../../DataServices/RequestSentDetailsDS";
import { IoCloseOutline } from "react-icons/io5";
import { insertLog } from "../../Logs/InsertLog";



const SendEmail = ({ vin, datasetID, datasetName, agencyName, fromEmail, toEmails: initialToEmails = [], onClose, waitDays, mailHistory = [], refreshMailHistory }) => {

    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const requestSentDS = new RequestSentDetailsDS();


    const [mailSubject, setMailSubject] = useState("");
    const [mailBody, setMailBody] = useState("");
    const [attachments, setAttachments] = useState([]);
    const fileInputRef = useRef(null);
    const [toEmails, setToEmails] = useState(initialToEmails);
    const [toInput, setToInput] = useState("");
    const toInputRef = useRef(null);

    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];

    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [showSendDropdown, setShowSendDropdown] = useState(false);
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleHour, setScheduleHour] = useState("");
    const [scheduleMinute, setScheduleMinute] = useState("");

    const [minDate, setMinDate] = useState("");
    const [minHour, setMinHour] = useState("00");
    const [minMinute, setMinMinute] = useState("00");
    const sendDropdownRef = useRef(null);

    const todayStr = new Date().toISOString().split("T")[0];


    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);

    const [ccEmails, setCcEmails] = useState([]);
    const [ccInput, setCcInput] = useState("");
    const ccInputRef = useRef(null);

    const [bccEmails, setBccEmails] = useState([]);
    const [bccInput, setBccInput] = useState("");
    const bccInputRef = useRef(null);
    const [previewFile, setPreviewFile] = useState(null);


    const checkRecentMailSent = () => {
        if (!waitDays || mailHistory.length === 0) return null;

        const waitMs = waitDays * 24 * 60 * 60 * 1000; // convert days to ms
        const now = new Date();

        // Find the most recent sent mail
        const recentMail = mailHistory
            .filter(item => item.status === "sent")
            .sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt))[0];

        if (!recentMail) return null;

        const sentAt = new Date(recentMail.sentAt);
        const diffMs = now - sentAt;

        if (diffMs < waitMs) {
            const remainingMs = waitMs - diffMs;
            const remainingHours = Math.ceil(remainingMs / (1000 * 60 * 60));
            const remainingDays = Math.floor(remainingHours / 24);
            const remainingHrsOnly = remainingHours % 24;

            return {
                sentAt,
                remainingHours,
                remainingDays,
                remainingHrsOnly
            };
        }

        return null;
    };
    // console.log("datset:: ",datasetID)
    const checkRecentScheduledMail = () => {
        if (!waitDays || mailHistory.length === 0) return null;

        const waitMs = waitDays * 24 * 60 * 60 * 1000;
        const now = new Date();

        const recentMail = mailHistory
            .filter(item => item.status === "sent" && item.isScheduled && item.scheduleTime)
            .sort((a, b) => new Date(b.scheduleTime) - new Date(a.scheduleTime))[0];

        if (!recentMail) return null;

        const scheduleAt = new Date(recentMail.scheduleTime);
        const diffMs = Math.abs(now - scheduleAt);

        if (diffMs < waitMs) {
            const remainingMs = waitMs - diffMs;
            const remainingHours = Math.ceil(remainingMs / (1000 * 60 * 60));
            const remainingDays = Math.floor(remainingHours / 24);
            const remainingHrsOnly = remainingHours % 24;
            return { scheduleAt, remainingHours, remainingDays, remainingHrsOnly };
        }

        return null;
    };

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        const maxSize = 20 * 1024 * 1024;
        newFiles.forEach((file) => {

            if (file.type !== "application/pdf") {
                showToast({ message: `${file.name} is not a PDF file` });
                return;
            }
            if (file.size > maxSize) {
                showToast({ message: `${file.name} exceeds 20MB limit` });
                return;
            }

            const isDuplicate = attachments.some(a => a.name === file.name && a.size === file.size);
            if (isDuplicate) {
                showToast({ message: `${file.name} is already attached` });
                return;
            }

            setAttachments(prev => [...prev, file]);
        });

        e.target.value = "";
    };


    const handleToKeyDown = (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
            e.preventDefault();
            addEmail(toInput.trim());
        }
        if (e.key === "Backspace" && toInput === "" && toEmails.length > 0) {
            setToEmails(prev => prev.slice(0, -1));
        }
    };

    const addEmail = (email) => {
        if (!email) return;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showToast({ message: "Invalid email address" });
            return;
        }
        if (toEmails.includes(email)) {
            showToast({ message: "Email already added" });
            setToInput("");
            return;
        }

        if (ccEmails.includes(email)) {
            showAlert(`"${email}" already exists in Cc.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setToInput(""); return;
        }
        if (bccEmails.includes(email)) {
            showAlert(`"${email}" already exists in Bcc.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setToInput(""); return;
        }

        setToEmails(prev => [...prev, email]);
        setToInput("");
    };

    const removeToEmail = (index) => {
        setToEmails(prev => prev.filter((_, i) => i !== index));
    };

    const handleToBlur = () => {
        if (toInput.trim()) addEmail(toInput.trim());
    };

    const removeAttachment = (index) => {
        setAttachments(prev => prev.filter((_, i) => i !== index));
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handlePreviewFile = (file) => {
        const url = URL.createObjectURL(file);
        setPreviewFile({ name: file.name, url });
    };

    const closePreview = () => {
        if (previewFile?.url) URL.revokeObjectURL(previewFile.url);
        setPreviewFile(null);
    };

    const handleCcKeyDown = (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
            e.preventDefault();
            addCcEmail(ccInput.trim());
        }
        if (e.key === "Backspace" && ccInput === "" && ccEmails.length > 0) {
            setCcEmails(prev => prev.slice(0, -1));
        }
    };

    const addCcEmail = (email) => {
        if (!email) return;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) { showToast({ message: "Invalid CC email address" }); return; }
        if (ccEmails.includes(email)) { showToast({ message: "CC Email already added" }); setCcInput(""); return; }

        if (toEmails.includes(email)) {
            showAlert(`"${email}" already exists in To.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setCcInput(""); return;
        }
        if (bccEmails.includes(email)) {
            showAlert(`"${email}" already exists in Bcc.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setCcInput(""); return;
        }

        setCcEmails(prev => [...prev, email]);
        setCcInput("");
    };

    const removeCcEmail = (index) => setCcEmails(prev => prev.filter((_, i) => i !== index));
    const handleCcBlur = () => { if (ccInput.trim()) addCcEmail(ccInput.trim()); };

    // ── BCC handlers ──
    const handleBccKeyDown = (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
            e.preventDefault();
            addBccEmail(bccInput.trim());
        }
        if (e.key === "Backspace" && bccInput === "" && bccEmails.length > 0) {
            setBccEmails(prev => prev.slice(0, -1));
        }
    };

    const addBccEmail = (email) => {
        if (!email) return;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) { showToast({ message: "Invalid BCC email address" }); return; }
        if (bccEmails.includes(email)) { showToast({ message: "BCC Email already added" }); setBccInput(""); return; }

        if (toEmails.includes(email)) {
            showAlert(`"${email}" already exists in To.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setBccInput(""); return;
        }
        if (ccEmails.includes(email)) {
            showAlert(`"${email}" already exists in Cc.`, [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]);
            setBccInput(""); return;
        }

        setBccEmails(prev => [...prev, email]);
        setBccInput("");
    };

    const removeBccEmail = (index) => setBccEmails(prev => prev.filter((_, i) => i !== index));
    const handleBccBlur = () => { if (bccInput.trim()) addBccEmail(bccInput.trim()); };


    const clearMailForm = () => {

        showAlert(
            "Are you sure you want to clear the mail ?",
            [
                {
                    label: "No",
                    onClick: () => { },
                    color: "#9ca3af"
                },
                {
                    label: "Yes",
                    color: "var(--buttonColor)",
                    onClick: () => {

                        setMailSubject("");
                        setMailBody("");
                        setAttachments([]);
                        setToEmails([]);
                        setToInput("");

                    }
                }
            ]
        );
    };



    // ── Common payload builder ──
    const buildEmailPayload = (folderPath = null, scheduledAt = null) => {
        const payload = {
            vinid: vin,
            datasetID,
            datasetName,
            to: toEmails,
            cc: ccEmails,
            bcc: bccEmails,
            from: 'njcriminal@vinsafety.com',
            subject: mailSubject,
            html: mailBody,
            s3Key: folderPath || ''
        };

        // Only add scheduleTime for scheduled emails
        if (scheduledAt) {
            payload.scheduleTime = scheduledAt.toISOString();
        }

        return payload;
    };

    const handleSendMail = async () => {

        // ── Validations ──
        if (toEmails.length === 0) { showToast({ message: "Please add at least one recipient" }); return; }
        if (!mailSubject.trim()) { showToast({ message: "Please enter a subject" }); return; }
        if (!mailBody.trim()) { showToast({ message: "Please enter a message body" }); return; };

        const recentCheck = checkRecentMailSent();

        if (recentCheck) {
            const { sentAt, remainingDays, remainingHrsOnly, remainingHours } = recentCheck;

            const sentDateStr = sentAt.toLocaleString("en-US", {
                month: "short", day: "numeric", year: "numeric",
                hour: "2-digit", minute: "2-digit"
            });

            const requiredDate = new Date(
                sentAt.getTime() + waitDays * 24 * 60 * 60 * 1000
            ).toLocaleString("en-US", {
                month: "short", day: "numeric", year: "numeric",
                hour: "2-digit", minute: "2-digit"
            });
            showAlert(
                `An email was already sent on ${sentDateStr}.\n\n You can send the mail again after ${requiredDate}`,
                [
                    {
                        label: "Cancel",
                        color: "#9ca3af",
                        onClick: () => { }
                    },
                    {
                        label: "Send Anyway",
                        color: "var(--buttonColor)",
                        onClick: () => proceedSendMail()
                    }
                ]
            );
            return;
        }

        await proceedSendMail();
    };

    const proceedSendMail = async () => {
        try {
            let folderPath = null;
            if (attachments.length > 0) {

                hud("Uploading attachments...");
                await new Promise(resolve => setTimeout(resolve, 100));

                const folderName = `${vin}_${Date.now()}`;
                folderPath = `Emails/${folderName}`;
                const bucketName = getEmailAttachmentBucketName();

                for (const file of attachments) {

                    const s3Key = `${folderPath}/${file.name}`;
                    try {
                        await uploadPdf(file, s3Key);
                    } catch (uploadError) {
                        stopHudRotation();
                        showAlert(
                            `Failed to upload ${file.name}`,
                            [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
                        );
                        return;
                    }
                }
            }
            hud("Sending email...");

            const payload = buildEmailPayload(folderPath);

            console.log("Final Payload", payload);

            const response = await requestSentDS.WS_Email_Send_Schedule_History(payload);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200) {

                insertLog(
                    `${userName} sent email for VIN '${vin}' and agency '${agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    vin || '',
                    'INSERT',
                    'WS_Email_Send_Schedule_History',
                    'SUCCESS',
                    ''
                );

                showToast({ message: "Email sent successfully" });
                setMailSubject("");
                setMailBody("");
                setAttachments([]);
                setToEmails([]);
                setToInput("");
                await refreshMailHistory?.();
                onClose?.();
            }
            else {
                insertLog(
                    `${userName} failed to send email for VIN '${vin}' and agency '${agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    vin || '',
                    'INSERT',
                    'WS_Email_Send_Schedule_History',
                    'FAILED',
                    'Unable to send email'
                );
                showAlert(body?.message || "Failed to send email.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
            }
            console.log("response_email", response);

        } catch (error) {
            console.error(error);
            insertLog(
                `${userName} failed to send email for VIN '${vin}' and agency '${agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                vin || '',
                'INSERT',
                'WS_Email_Send_Schedule_History',
                'FAILED',
                error.message
            );
            showAlert(
                error.message || "Failed to send email",
                [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
            );
        } finally {
            stopHudRotation();
        }
    }


    const getUSNowPlus5 = () => {
        const usNow = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );
        usNow.setMinutes(usNow.getMinutes() + 5);

        const date = `${usNow.getFullYear()}-${String(usNow.getMonth() + 1).padStart(2, "0")}-${String(usNow.getDate()).padStart(2, "0")}`;
        const hour = String(usNow.getHours()).padStart(2, "0");
        const minute = String(usNow.getMinutes()).padStart(2, "0");

        return { date, hour, minute };
    };

    const handleOpenSchedulesend = () => {


        if (toEmails.length === 0) { showToast({ message: "Please add at least one recipient" }); return; }
        if (!mailSubject.trim()) { showToast({ message: "Please enter a subject" }); return; }
        if (!mailBody.trim()) { showToast({ message: "Please enter a message body" }); return; }


        const { date, hour, minute } = getUSNowPlus5();

        setScheduleDate(date);
        setScheduleHour(hour);
        setScheduleMinute(minute);

        setMinDate(date);
        setMinHour(hour);
        setMinMinute(minute);

        setShowSendDropdown(false);
        setShowScheduleModal(true);
    };

    const handleScheduleSend = async () => {

        // if (toEmails.length === 0) { showToast({ message: "Please add at least one recipient" }); return; }
        // if (!mailSubject.trim()) { showToast({ message: "Please enter a subject" }); return; }
        // if (!mailBody.trim()) { showToast({ message: "Please enter a message body" }); return; }


        if (!scheduleDate) { showToast({ message: "Please select a date" }); return; }
        if (!scheduleHour || !scheduleMinute) { showToast({ message: "Please select a time" }); return; }

        // ── US Eastern → UTC conversion ──
        const [year, month, day] = scheduleDate.split("-").map(Number);
        const hour = Number(scheduleHour);
        const minute = Number(scheduleMinute);

        // Detect EDT (UTC-4) vs EST (UTC-5)
        const isEDT = (y, mo, d) => {
            // EDT starts: 2nd Sunday of March
            const marchSecondSunday = new Date(y, 2, 1);
            marchSecondSunday.setDate(1 + (7 - marchSecondSunday.getDay()) % 7 + 7);

            // EDT ends: 1st Sunday of November
            const novFirstSunday = new Date(y, 10, 1);
            novFirstSunday.setDate(1 + (7 - novFirstSunday.getDay()) % 7);

            const target = new Date(y, mo - 1, d);
            return target >= marchSecondSunday && target < novFirstSunday;
        };

        const offsetHours = isEDT(year, month, day) ? 4 : 5;

        // ── Fix: Date.UTC handles overflow automatically ──
        // e.g. hour=22 + offset=5 = 27 → Date.UTC rolls over to next day correctly
        const scheduledAt = new Date(Date.UTC(year, month - 1, day, hour + offsetHours, minute, 0));

        if (isNaN(scheduledAt.getTime())) {
            showToast({ message: "Invalid date/time selected" });
            return;
        }


        const usNowAtClick = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );
        const minAllowedAt = new Date(usNowAtClick.getTime() + 1 * 60 * 1000); // at least 1 min from now

        if (scheduledAt <= minAllowedAt) {
            showAlert(
                'Selected time has passed. Please pick a later time.',
                [
                    {
                        label: "OK",
                        color: "var(--buttonColor)",
                        onClick: () => { }
                    }
                ]
            );
            return;
        }

        if (scheduledAt <= new Date()) {
            showAlert(
                'Scheduled date must be in the future',
                [
                    {
                        label: "Ok",
                        color: "var(--buttonColor)",
                        onClick: () => { }
                    },

                ]
            );
            return;
        }

        const maxScheduleMs = 72 * 60 * 60 * 1000;
        const diffFromNow = scheduledAt - new Date();

        if (diffFromNow > maxScheduleMs) {
            showAlert(
                'You can only schedule emails within 72 hours (3 days) from now',
                [
                    {
                        label: "Ok",
                        color: "var(--buttonColor)",
                        onClick: () => { }
                    },

                ]
            );
            return;
        }


        console.log("US Eastern input :", `${scheduleDate} ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${isEDT(year, month, day) ? "EDT" : "EST"}`);

        const recentCheck = checkRecentScheduledMail();

        if (recentCheck) {
            const { scheduleAt, remainingDays, remainingHrsOnly, remainingHours, isScheduled, sentAt } = recentCheck;

            const scheduledDateStr = scheduleAt.toLocaleString("en-US", {
                timeZone: "America/New_York",
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });

            const requiredScheduledDate = new Date(
                scheduleAt.getTime() + waitDays * 24 * 60 * 60 * 1000
            ).toLocaleString("en-US", {
                timeZone: "America/New_York",
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });

            const timeLeft =
                remainingDays > 0
                    ? `${remainingDays}d ${remainingHrsOnly}h`
                    : `${remainingHours}h`;

            const message =
                isScheduled && !sentAt
                    ? `An email was already scheduled on ${scheduledDateStr}.\n\nYou can schedule the mail again after ${requiredScheduledDate}.`
                    : `An email was already scheduled sent on ${scheduledDateStr}.\n\nYou can send the mail again after ${requiredScheduledDate}.`;

            showAlert(message, [
                {
                    label: "Cancel",
                    color: "#9ca3af",
                    onClick: () => { }
                },
                {
                    label: "Schedule Anyway",
                    color: "var(--buttonColor)",
                    onClick: () => proceedScheduleSend(scheduleAt)
                }
            ]);

            return;
        }

        await proceedScheduleSend(scheduledAt);

    };

    const proceedScheduleSend = async (scheduledAt) => {
        try {
            let folderPath = null;

            if (attachments.length > 0) {
                hud("Uploading attachments...");
                await new Promise(resolve => setTimeout(resolve, 100));

                const folderName = `${vin}_${Date.now()}`;
                folderPath = `Emails/${folderName}`;
                const bucketName = getEmailAttachmentBucketName();

                for (const file of attachments) {
                    const s3Key = `${folderPath}/${file.name}`;

                    try {
                        await uploadPdf(file, s3Key);
                    }
                    catch (uploadError) {
                        stopHudRotation();
                        showAlert(`Failed to upload ${file.name}`,
                            [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
                        );
                        return;
                    }
                }
            }
            hud("Scheduling email...");


            const payload = buildEmailPayload(folderPath, scheduledAt);

            console.log("Final Payload", payload);

            const response = await requestSentDS.WS_Email_Send_Schedule_History(payload);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200) {
                showToast({ message: "Email scheduled successfully" });
                setMailSubject("");
                setMailBody("");
                setAttachments([]);
                setToEmails([]);
                setToInput("");
                setShowScheduleModal(false);
                await refreshMailHistory?.();
                onClose?.();
                insertLog(
                    `${userName} scheduled email for VIN '${vin}' and agency '${agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    vin || '',
                    'INSERT',
                    'WS_Email_Send_Schedule_History',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(
                    body?.message || "Failed to schedule email.",
                    [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
                );
                insertLog(
                    `${userName} failed to schedule email for VIN '${vin}' and agency '${agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    vin || '',
                    'INSERT',
                    'WS_Email_Send_Schedule_History',
                    'FAILED',
                    'Unable to schedule email'
                );
            }

        } catch (error) {
            console.error(error);
            showAlert(
                error.message || "Failed to schedule email",
                [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
            );
            insertLog(
                `${userName} failed to schedule email for VIN '${vin}' and agency '${agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                vin || '',
                'INSERT',
                'WS_Email_Send_Schedule_History',
                'FAILED',
                'Error occurred while scheduling email'
            );
        } finally {
            stopHudRotation();
        }
    }
    const normalizeBucketNamePart = (value) => (
        String(value)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const getEmailAttachmentBucketName = () => {
        if (!datasetID || !datasetName || !process.env.REACT_APP_ALIAS) {
            throw new Error("Dataset ID, Dataset Name, and alias are required to upload email attachments.");
        }

        const datasetIdPart = normalizeBucketNamePart(datasetID);
        const datasetNamePart = normalizeBucketNamePart(datasetName);
        const aliasPart = normalizeBucketNamePart(process.env.REACT_APP_ALIAS);

        if (!datasetIdPart || !datasetNamePart || !aliasPart) {
            throw new Error("Dataset ID, Dataset Name, and alias must contain valid S3 bucket characters.");
        }

        return `${datasetIdPart}-${datasetNamePart}-files-${aliasPart}`;

    };

    const uploadPdf = async (file, key) => {
        const idToken = localStorage.getItem("idToken");
        const bucketName = getEmailAttachmentBucketName();

        console.log("Bucket Name::", bucketName);
        console.log("S3 Key::", key);

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                        idToken,
                },
            }),
        });
        const command = new PutObjectCommand({
            Bucket: bucketName,
            Key: key,
            Body: await file.arrayBuffer(),
            ContentType: file.type,
        });

        await s3.send(command);
        return key;
    };




    return (

        <div className="compose-mail-overlay" >

            <div className="compose-mail-modal">

                <div className="compose-mail-header">
                    <span className="compose-mail-title">New Mail</span>

                    <IoCloseOutline className="compose-mail-close" onClick={onClose} />
                </div>

                <div className="mail-section-body">

                    {/* To field */}
                    <div className="mail-row" onClick={() => toInputRef.current.focus()}>
                        <span className="mail-row-label">To</span>
                        <div className="mail-to-field">
                            {toEmails.map((email, i) => (
                                <div className="mail-to-chip" key={i}>
                                    <span>{email}</span>
                                    <button className="mail-to-chip-remove"
                                        onClick={(e) => { e.stopPropagation(); removeToEmail(i); }}>✕</button>
                                </div>
                            ))}
                            <input
                                ref={toInputRef}
                                type="text"
                                className="mail-to-input"
                                placeholder={toEmails.length === 0 ? "" : ""}
                                value={toInput}
                                onChange={(e) => setToInput(e.target.value)}
                                onKeyDown={handleToKeyDown}
                                onBlur={handleToBlur}
                            />
                        </div>


                        <div className="mail-cc-bcc-btns">
                            {!showCc && (
                                <span className="mail-cc-btn" onClick={(e) => {
                                    e.stopPropagation();
                                    setShowCc(true);
                                    setTimeout(() => ccInputRef.current?.focus(), 50);
                                }}>Cc</span>
                            )}
                            {!showBcc && (
                                <span className="mail-cc-btn" onClick={(e) => {
                                    e.stopPropagation();
                                    setShowBcc(true);
                                    setTimeout(() => bccInputRef.current?.focus(), 50);
                                }}>Bcc</span>
                            )}
                        </div>
                    </div>

                    {showCc && (
                        <div className="mail-row" onClick={() => ccInputRef.current.focus()}>
                            <span className="mail-row-label">Cc</span>
                            <div className="mail-to-field">
                                {ccEmails.map((email, i) => (
                                    <div className="mail-to-chip" key={i}>
                                        <span>{email}</span>
                                        <button className="mail-to-chip-remove"
                                            onClick={(e) => { e.stopPropagation(); removeCcEmail(i); }}>✕</button>
                                    </div>
                                ))}
                                <input
                                    ref={ccInputRef}
                                    type="text"
                                    className="mail-to-input"
                                    value={ccInput}
                                    onChange={(e) => setCcInput(e.target.value)}
                                    onKeyDown={handleCcKeyDown}
                                    onBlur={handleCcBlur}
                                />
                            </div>
                            <IoCloseOutline className="mail-cc-close" onClick={() => { setShowCc(false); setCcEmails([]); setCcInput(""); }} />

                        </div>
                    )}

                    {/* ── BCC field ── */}
                    {showBcc && (
                        <div className="mail-row" onClick={() => bccInputRef.current.focus()}>
                            <span className="mail-row-label">Bcc</span>
                            <div className="mail-to-field">
                                {bccEmails.map((email, i) => (
                                    <div className="mail-to-chip" key={i}>
                                        <span>{email}</span>
                                        <button className="mail-to-chip-remove"
                                            onClick={(e) => { e.stopPropagation(); removeBccEmail(i) }}>✕</button>
                                    </div>
                                ))}
                                <input
                                    ref={bccInputRef}
                                    type="text"
                                    className="mail-to-input"
                                    value={bccInput}
                                    onChange={(e) => setBccInput(e.target.value)}
                                    onKeyDown={handleBccKeyDown}
                                    onBlur={handleBccBlur}
                                />
                            </div>
                            <IoCloseOutline className="mail-cc-close" onClick={() => { setShowBcc(false); setBccEmails([]); setBccInput(""); }} />
                        </div>
                    )}

                    {/* Subject */}
                    <div className="mail-row">
                        <span className="mail-row-label">Subject</span>
                        <input
                            type="text"
                            className="mail-row-input"
                            // placeholder="Enter subject..."
                            value={mailSubject}
                            onChange={(e) => setMailSubject(e.target.value)}
                            maxLength={200}
                        />
                    </div>

                    {/* Body */}
                    <textarea
                        className="mail-body-textarea"
                        placeholder="Type your message here..."
                        value={mailBody}
                        onChange={(e) => setMailBody(e.target.value)}
                        rows={7}
                    />

                    {/* Attachments */}
                    <div className="mail-file-list">
                        {attachments.map((file, i) => (
                            <div className="mail-file-chip" key={i}
                                onClick={() => handlePreviewFile(file)}
                                title="Click to preview">

                                {/* PDF icon */}
                                <div className="mail-file-icon">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8 13h8v1H8v-1zm0 3h8v1H8v-1zm0-6h3v1H8v-1z" />
                                    </svg>
                                </div>

                                {/* Name + size */}
                                <div className="mail-file-info">
                                    <span className="mail-file-name">{file.name}</span>
                                    <span className="mail-file-size">{formatFileSize(file.size)}</span>
                                </div>

                                {/* Remove */}
                                <button className="mail-file-chip-remove"
                                    onClick={(e) => { e.stopPropagation(); removeAttachment(i); }}>✕</button>
                            </div>
                        ))}
                    </div>

                    {/* Footer */}
                    <div className="mail-footer">
                        <div className="mail-footer-tools">
                            <button className="mail-tool-btn" title="Attach files"
                                onClick={() => fileInputRef.current.click()}>
                                <MdAttachFile />
                            </button>
                            <input
                                type="file"
                                multiple ref={fileInputRef}
                                accept=".pdf,application/pdf"
                                onChange={handleFileChange}
                                style={{ display: "none" }} />
                        </div>

                        <div className="mail-footer-actions">
                            {/* ── Split Send Button (Gmail style) ── */}
                            <div className="mail-send-split" ref={sendDropdownRef}>

                                {/* Main send button */}
                                <button className="mail-btn-send mail-btn-send-main" onClick={handleSendMail}>
                                    Send
                                </button>

                                <button
                                    className="mail-btn-send mail-btn-send-chevron"
                                    title="More send options"
                                    onClick={() => setShowSendDropdown(prev => !prev)}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </button>

                                {/* Dropdown */}
                                {showSendDropdown && (
                                    <div className="mail-send-dropdown">
                                        <button
                                            className="mail-send-dropdown-item"
                                            onClick={handleOpenSchedulesend} >

                                            <MdScheduleSend color="var(--buttonColor)" size={18} />

                                            Schedule send
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>



                </div>



                {showScheduleModal && (
                    <div className="schedule-modal-overlay">
                        <div className="schedule-modal" onClick={(e) => e.stopPropagation()}>

                            <div className="schedule-modal-header">
                                <span>Pick date and time</span>
                                <button className="schedule-modal-close"
                                    onClick={() => setShowScheduleModal(false)}>✕</button>
                            </div>

                            <div className="schedule-modal-body">

                                {/* Date */}
                                <div className="schedule-field">
                                    <label className="schedule-label">Date</label>
                                    <input
                                        type="date"
                                        className="schedule-date-input"
                                        value={scheduleDate}
                                        min={minDate}
                                        onChange={(e) => {
                                            setScheduleDate(e.target.value);
                                            if (e.target.value !== minDate) {
                                                setScheduleHour("00");
                                                setScheduleMinute("00");
                                            } else {
                                                // back to today — restore min values
                                                setScheduleHour(minHour);
                                                setScheduleMinute(minMinute);
                                            }
                                        }}
                                    />
                                </div>

                                {/* Time */}
                                <div className="schedule-field">
                                    <label className="schedule-label">Time (US Eastern)</label>
                                    <div className="schedule-time-row">

                                        {/* Hour */}
                                        <select
                                            className="schedule-time-select"
                                            value={scheduleHour}
                                            onChange={(e) => {
                                                setScheduleHour(e.target.value);
                                                // if hour changes to a later hour, reset minute to 00
                                                // if hour is minHour, reset minute to minMinute
                                                if (scheduleDate === minDate && e.target.value === minHour) {
                                                    setScheduleMinute(minMinute);
                                                } else {
                                                    setScheduleMinute("00");
                                                }
                                            }}
                                        >
                                            {Array.from({ length: 24 }, (_, i) =>
                                                String(i).padStart(2, "0")
                                            )
                                                .filter((h) => {
                                                    // only filter hours if selected date is today (US Eastern)
                                                    if (scheduleDate === minDate) {
                                                        return Number(h) >= Number(minHour);
                                                    }
                                                    return true;
                                                })
                                                .map((h) => (
                                                    <option key={h} value={h}>{h}</option>
                                                ))}
                                        </select>

                                        <span className="schedule-time-sep">:</span>

                                        {/* Minute */}
                                        <select
                                            className="schedule-time-select"
                                            value={scheduleMinute}
                                            onChange={(e) => setScheduleMinute(e.target.value)}
                                        >
                                            {Array.from({ length: 60 }, (_, i) =>
                                                String(i).padStart(2, "0")
                                            )
                                                .filter((m) => {
                                                    // only filter minutes if today + same hour as min
                                                    if (scheduleDate === minDate && scheduleHour === minHour) {
                                                        return Number(m) >= Number(minMinute);
                                                    }
                                                    return true;
                                                })
                                                .map((m) => (
                                                    <option key={m} value={m}>{m}</option>
                                                ))}
                                        </select>

                                    </div>
                                </div>

                            </div>

                            <div className="schedule-modal-footer">
                                <button className="schedule-btn-confirm" onClick={handleScheduleSend}>
                                    Schedule send
                                </button>
                            </div>

                        </div>
                    </div>
                )}


                {previewFile && (
                    <div className="file-preview-overlay" onClick={closePreview}>
                        <div className="file-preview-modal" onClick={(e) => e.stopPropagation()}>

                            <div className="file-preview-header">
                                <span className="file-preview-title">{previewFile.name}</span>
                                <button className="file-preview-close" onClick={closePreview}>✕</button>
                            </div>

                            <iframe
                                src={previewFile.url}
                                className="file-preview-iframe"
                                title={previewFile.name}
                            />

                        </div>
                    </div>
                )}

            </div>
        </div>

    )
}

export default SendEmail;
